"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.idaLogoCell = exports.formTitle = exports.IdaLogo = exports.baseCell = void 0;
var idaLogo_png_1 = __importDefault(require("../assets/idaLogo.png"));
exports.baseCell = {
    borderWidth: { top: 1, bottom: 1, left: 1, right: 1 },
    borderColor: { top: 'gray', bottom: 'gray', left: 'gray', right: 'gray' },
    borderStyle: { top: 'solid', bottom: 'solid', left: 'solid', right: 'solid' },
};
var IdaLogo = function (_a) {
    var _b = _a.colSpan, colSpan = _b === void 0 ? 5 : _b, _c = _a.hight, hight = _c === void 0 ? 75 : _c;
    return __assign(__assign({}, exports.baseCell), { type: 'image', src: idaLogo_png_1.default, textAlign: 'center', colSpan: colSpan, height: hight !== null && hight !== void 0 ? hight : 50 });
};
exports.IdaLogo = IdaLogo;
var formTitle = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.colSpan, colSpan = _c === void 0 ? 1 : _c;
    return __assign(__assign({}, exports.baseCell), { type: 'text', text: title, bold: true, colSpan: colSpan, textAlign: 'center' });
};
exports.formTitle = formTitle;
exports.idaLogoCell = __assign(__assign({}, exports.baseCell), { type: 'image', src: idaLogo_png_1.default, height: 50, colSpan: 4, textAlign: 'center' });
